import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "nav-links" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

// Keine Logik erforderlich

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h1", null, "🎵 SoundBattle", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/settings",
          class: "nav-link"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" ⚙️ ", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})